export type DrillDownPathItem = { level: string; value: string };
export type PathSummaryItem = { level: string; count: number; startIndex: number; firstValue?: string };

export const summarizeDrillDownPath = (path: DrillDownPathItem[]) => {
  const summary: PathSummaryItem[] = [];
  path.forEach((item, index) => {
    const last = summary[summary.length - 1];
    if (last && last.level === item.level) {
      last.count += 1;
    } else {
      summary.push({ level: item.level, count: 1, startIndex: index, firstValue: item.value });
    }
  });
  return summary;
};

export const inferRootLevelsFromMap = (
  hierarchyMap?: Record<string, string[]>,
  explicitRoots?: string[]
): string[] => {
  if (!hierarchyMap || Object.keys(hierarchyMap).length === 0) {
    return [];
  }
  if (explicitRoots && explicitRoots.length > 0) {
    return explicitRoots;
  }

  const childLevels = new Set<string>();
  Object.values(hierarchyMap).forEach(children => {
    if (Array.isArray(children)) {
      children.forEach(child => childLevels.add(child));
    }
  });

  const inferredRoots = Object.keys(hierarchyMap).filter(level => !childLevels.has(level));
  return inferredRoots.length > 0 ? inferredRoots : Object.keys(hierarchyMap);
};

export const getNextLevelsFromHierarchyMap = (
  hierarchyMap?: Record<string, string[]>,
  rootLevels?: string[],
  pathSummary: PathSummaryItem[] = []
): string[] => {
  if (!hierarchyMap || Object.keys(hierarchyMap).length === 0) {
    return [];
  }

  if (pathSummary.length === 0) {
    return inferRootLevelsFromMap(hierarchyMap, rootLevels);
  }

  const lastLevel = pathSummary[pathSummary.length - 1].level;
  const children = hierarchyMap[lastLevel] || [];
  return Array.from(new Set(children.filter(Boolean)));
};

export const getAllHierarchyLevelsFromMap = (
  hierarchyMap?: Record<string, string[]>,
  explicitRoots?: string[]
): string[] => {
  const levelSet = new Set<string>();

  if (explicitRoots && explicitRoots.length > 0) {
    explicitRoots.forEach(level => levelSet.add(level));
  }

  if (!hierarchyMap || Object.keys(hierarchyMap).length === 0) {
    return Array.from(levelSet);
  }

  Object.keys(hierarchyMap).forEach(level => levelSet.add(level));
  Object.values(hierarchyMap).forEach(children => {
    if (Array.isArray(children)) {
      children.forEach(child => levelSet.add(child));
    }
  });

  return Array.from(levelSet);
};


